module.exports = __webpack_public_path__ + "static/img/background.ef615f14.svg";